<template>
  <v-layout>
    <v-flex xs12 sm12>
      <v-card>
        <v-img
          :src="`${FrontendPath}/public/404.jpg`"
          aspect-ratio="2.90"
        ></v-img>
         
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import {FrontendPath} from '../vuex/api'
  export default {
    data: () => ({
      
    }),

    computed: {
      FrontendPath(){
        return FrontendPath;
      },      
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/page-404.vue